export default __webpack_public_path__ + "static/media/surf.d478ca72.png";